import styles from './DescriptionTerm.module.scss';

interface Props {
  children?: React.ReactNode;
}

const DescriptionTerm: React.FC<Props> = ({ children }) => (
  <div className={styles.wrapper}>{children}</div>
);

export default DescriptionTerm;
